import {ChangeDetectionStrategy, Component, effect, inject} from '@angular/core';
import { NgToastComponent, NgToastService, TOAST_POSITIONS, ToastPosition } from 'ng-angular-popup';
import { AlertService } from '~core/services/ui/alert.service';
import { AlertType} from "~core/constants/alerts.constants";

@Component({
  selector: 'app-toast',
  imports: [NgToastComponent],
  templateUrl: './toast-stack.component.html',
  styleUrl: './toast-stack.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ToastStackComponent {
  TOAST_POSITIONS = TOAST_POSITIONS;
  private toastService =inject(NgToastService);
  private readonly alertService = inject(AlertService);
  readonly alert = this.alertService.alert;

  constructor() {
    effect(() => {
      /*for (const element of this.alertElements()) {
        const native = element.nativeElement as HTMLElement & { toast?: () => void };
        const alertId = native.getAttribute('id');
        if (alertId && !this.toastedAlertIds.has(alertId)) {
          native.toast?.();
          this.toastedAlertIds.add(alertId);
        }
      }*/
      if (this.alert()!==null){
        const newalert=this.alert();
        if (newalert?.type===AlertType.SUCCESS){
          this.toastService.success(newalert.message,'',newalert.duration,newalert.hasCountdown,true,false);
        }
        else if (newalert?.type===AlertType.ERROR){
          this.toastService.danger(newalert.message,'',newalert.duration,newalert.hasCountdown,true,false);
        }
      }
    });
  }

}
